module.exports = __webpack_public_path__ + "img/bs.d3aab710.svg";